var React = require('react');

function Ingredients (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M6,19.125h9.921A1.5,1.5,0,0,0,17.4,17.876l2.637-15.5a1.5,1.5,0,0,1,1.479-1.248H22.5","key":1}),React.createElement("path",{"className":"a","d":"M7.875,21.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375","key":2}),React.createElement("path",{"className":"a","d":"M15.375,21.375A.375.375,0,1,1,15,21.75a.375.375,0,0,1,.375-.375","key":3}),React.createElement("path",{"className":"a","d":"M17.953,14.625H5.882a3,3,0,0,1-2.91-2.272l-1.45-5.8a.75.75,0,0,1,.728-.932H19.484","key":4}),React.createElement("path",{"className":"a","d":"M17.255,5.625l-3-3a1.5,1.5,0,0,0-2.121,0l-3,3","key":5}),React.createElement("path",{"className":"a","d":"M11.261,3.493,7.741,2.46A1.5,1.5,0,0,0,5.88,3.477L5.25,5.625","key":6})]);
}

Ingredients.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Ingredients;

Ingredients.default = Ingredients;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/ingredients.svg
// module id = 1071
// module chunks = 0